// extracted by mini-css-extract-plugin
export default {"taskIcon":"task-list_taskIcon__G8cSH","taskInput":"task-list_taskInput__IGph4"};